import Events from 'lib/analytics/eventTags'
import { parseSearch } from './url-utils'
import serverProps from './serverProps'

const MGM_SUB_FLOW = 'mgm_send_money'

export function getTrafficSource(href) {
  const { mgmTrafficSource = '' } = serverProps
  return mgmTrafficSource || getTrafficSourceFromUrl(href)
}

export function getTrafficSourceFromUrl(href) {
  const params = href ? parseSearch(href) : parseSearch()
  const { traffic_source = '' } = params
  return traffic_source
}

export function setMgmTrackingCommonProps(href) {
  const source = getTrafficSource(href)
  Events.updateCommonProps({
    sub_flow: MGM_SUB_FLOW,
    ...(source && { source }),
  })
}
